import React, { Fragment, Component } from 'react'
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button, Label,
    Spinner,
} from "reactstrap"
import Select from '../../../../helpers/ui/CustomSelect'

import { Link } from 'react-router-dom'
import apiResponse from '../../../../services/apiResponse'
import { cancelToken } from '../../../../services/adapters/kepegawaian/menuService'

import IndexBloc from '../Index/Blocs/IndexBloc'
import OrganizationChart from '@dabeng/react-orgchart'
import NodeChart from './NodeChart'

import _ from 'lodash'

const ext = [
    { value: 'png', label: 'Image PNG' },
    { value: 'pdf', label: 'PDF' }
]
class ChartView extends Component {

    source
    indexBloc = new IndexBloc()
    constructor(props) {
        super(props)
        this.state = {
            detail: [],
            filename: 'orgchart',
            fileextension: 'png'
        }
        this.orgChart = React.createRef()
    }

    loadHirarki = async () => {
        const query = {
            uuid: this.props.uuid,
            period: this.props.period
        }

        await this.indexBloc.fetchHirarki(query, this.source.token)
    }

    setTokenAPI = () => {
        if (typeof this.source != typeof undefined) {
            this.source.cancel();
        }
        this.source = cancelToken()
        this.loadHirarki()
    }

    exportTo = () => {
        const { filename, fileextension } = this.state
        this.orgChart.current.exportTo(filename, fileextension)
    }

    renameChildKey = (array, key) => {
        if (Array.isArray(array)) {
            array.forEach(element => {
                element['children'] = element[key]
                delete element[key]
            });
        } else {
            delete array[key]
        }
                
        return array
    }

    renameKeys(node, keysMaps) {
        if(!_.isObject(node)) return node
        if(Array.isArray(node)) return node.map(item => this.renameKeys(item, keysMaps))

        return Object.entries(node).reduce((result, [key, value]) => {
            const newKey = keysMaps[key] || key;
            return {
                ...result,
                [newKey]: this.renameKeys(value, keysMaps)

            };
        }, {});
    }

    generateChart = (result) => {
        let mainParent = []
        const { detail, hirarki } = result
      
        mainParent = {
            ...hirarki
        }
                    
        this.setState({ detail: mainParent })
    }

    componentDidMount() {
        this.setTokenAPI()

        this.indexBloc.hirarkiChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.generateChart(result.data.response)
                    break;
                case apiResponse.ERROR:
                    break;
                default:
                    break;
            }
        })

    }

    componentWillUnmount() {
        this.indexBloc.detailChannel?.unsubscribe()
    }


    onNameChange = event => {
        this.setState({ 
            filename: event.target.value
        })
    };

    onExtensionChange = event => {
        this.setState({
            fileextension: event.target.value
        })
    };


    render() {
        const { detail } = this.state
        
        return (
            <Fragment>
                <Container fluid>
                    <Card>
                        <CardBody>
                            <div className="float-end">
                                <Link to={`/master/struktur-organisasi.html`}>
                                    <Button outline color="primary"><i className="uil uil-backward"></i> Kembali</Button>
                                </Link>
                            </div>
                            <CardTitle>Chart Struktur Organisasi</CardTitle>
                            <hr/>
                            <Row>
                                <Col md="12">
                                    <Row>
                                        <Label className="col-md-1 col-form-label">Nama File</Label>
                                        <Col md="3">
                                            <input placeholder="Nama File" className="form-control"
                                                value={this.state.filename}
                                                onChange={this.onNameChange} 
                                            />
                                        </Col>
                                        <Label className="col-md-1 col-form-label">Ekstensi File</Label>
                                        <Col md="3">
                                            <Select
                                                options={ext}
                                                isAvForm={false}
                                                isSearchable={false}
                                                defaultValue={this.state.fileextension}
                                                onChange={opt => this.setState({fileextension: opt.value})}
                                            />
                                        </Col>
                                        <Col md="3">
                                            <Button color="primary" onClick={this.exportTo}>Export Chart</Button>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col md="12">
                                    <OrganizationChart 
                                        chartClass="myChart"
                                        datasource={detail} 
                                        NodeTemplate={NodeChart} 
                                        collapsible={false} 
                                        pan={true}
                                        zoom={true} 
                                        ref={this.orgChart}
                                    />
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>

                </Container>



            </Fragment>
        )
    }
}

export default ChartView

